import { Button } from '@/components/shadcn/button'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/shadcn/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { cn } from '@/lib/utils'
import { IconCheckMarkOutline } from '@icons/IconCheckMarkOutline'
import { IconDownChevronOutline } from '@icons/IconDownChevronOutline'
import { useState } from 'react'
import { DAY_OF_WEEK_OPTIONS, formatDaysOfWeekLabel } from './cronExpressionUtils'

type DaysOfWeekSelectProps = {
  selectedDays: number[]
  onSelectionChange: (days: number[]) => void
  className?: string
  disabled?: boolean
}

export function DaysOfWeekSelect({ selectedDays, onSelectionChange, className, disabled }: DaysOfWeekSelectProps) {
  const [open, setOpen] = useState(false)

  const handleSelect = (day: number) => {
    const isSelected = selectedDays.includes(day)
    const nextSelection = isSelected ? selectedDays.filter((value) => value !== day) : [...selectedDays, day]

    onSelectionChange(nextSelection.length ? nextSelection : [day])
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className={cn('h-10 min-w-24 justify-between gap-2 px-3 font-normal', className)}
        >
          <span className="truncate">{formatDaysOfWeekLabel(selectedDays)}</span>
          <IconDownChevronOutline className="size-3 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search days..." />
          <CommandList>
            <CommandEmpty>No days found.</CommandEmpty>
            <CommandGroup>
              {DAY_OF_WEEK_OPTIONS.map((option) => {
                const isSelected = selectedDays.includes(option.value)
                return (
                  <CommandItem key={option.value} value={option.label} onSelect={() => handleSelect(option.value)}>
                    <span className="font-medium">{option.label}</span>
                    <IconCheckMarkOutline className={cn('ml-auto', isSelected ? 'opacity-100' : 'opacity-0')} />
                  </CommandItem>
                )
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
